export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13693.594970da.jpg";